// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"121":"privacy_en","327":"privacy_ar","443":"about"}[chunkId] + "-legacy." + {"121":"31378da5","327":"86c469df","443":"a53b8bda"}[chunkId] + ".js";
};